/**
 * useShop composable
 *
 * Provides reactive access to the current shop configuration.
 * The shop is determined by window.location.hostname.
 */

import { computed } from "vue";
import { getCurrentShopKey, getShopConfig } from "./shopConfig";

export function useShop() {
  const shopKey = computed(() => {
    return getCurrentShopKey();
  });

  const shopConfig = computed(() => getShopConfig(shopKey.value));

  const isDe = computed(() => shopKey.value === "de");
  const isIntl = computed(() => shopKey.value === "intl");

  return {
    shopKey,
    shopConfig,
    isDe,
    isIntl,
  };
}
